function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2015 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { get } from '@vaadin/component-base/src/path-utils.js';
import { generateUniqueId } from '@vaadin/component-base/src/unique-id-utils.js';
import { Virtualizer } from '@vaadin/component-base/src/virtualizer.js';
import { ComboBoxPlaceholder } from './vaadin-combo-box-placeholder.js';
/**
 * @polymerMixin
 */

export var ComboBoxScrollerMixin = function ComboBoxScrollerMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(ComboBoxScrollerMixin, _superClass);

    var _super = _createSuper(ComboBoxScrollerMixin);

    function ComboBoxScrollerMixin() {
      var _this;

      _classCallCheck(this, ComboBoxScrollerMixin);

      _this = _super.call(this);
      _this.__boundOnItemClick = _this.__onItemClick.bind(_assertThisInitialized(_this));
      return _this;
    }
    /** @private */


    _createClass(ComboBoxScrollerMixin, [{
      key: "_viewportTotalPaddingBottom",
      get: function get() {
        if (this._cachedViewportTotalPaddingBottom === undefined) {
          var itemsStyle = window.getComputedStyle(this.$.selector);
          this._cachedViewportTotalPaddingBottom = [itemsStyle.paddingBottom, itemsStyle.borderBottomWidth].map(function (v) {
            return parseInt(v, 10);
          }).reduce(function (sum, v) {
            return sum + v;
          });
        }

        return this._cachedViewportTotalPaddingBottom;
      }
      /** @protected */

    }, {
      key: "ready",
      value: function ready() {
        _get(_getPrototypeOf(ComboBoxScrollerMixin.prototype), "ready", this).call(this);

        this.setAttribute('role', 'listbox'); // Ensure every instance has unique ID

        this.id = "".concat(this.localName, "-").concat(generateUniqueId()); // Allow extensions to customize tag name for the items

        this.__hostTagName = this.constructor.is.replace('-scroller', '');
        this.addEventListener('click', function (e) {
          return e.stopPropagation();
        });

        this.__patchWheelOverScrolling();

        this.__virtualizer = new Virtualizer({
          createElements: this.__createElements.bind(this),
          updateElement: this._updateElement.bind(this),
          elementsContainer: this,
          scrollTarget: this,
          scrollContainer: this.$.selector
        });
      }
      /**
       * Requests an update for the virtualizer to re-render items.
       */

    }, {
      key: "requestContentUpdate",
      value: function requestContentUpdate() {
        if (this.__virtualizer) {
          this.__virtualizer.update();
        }
      }
      /**
       * Scrolls an item at given index into view and adjusts `scrollTop`
       * so that the element gets fully visible on Arrow Down key press.
       * @param {number} index
       */

    }, {
      key: "scrollIntoView",
      value: function scrollIntoView(index) {
        var _this2 = this;

        if (!(this.opened && index >= 0)) {
          return;
        }

        var visibleItemsCount = this._visibleItemsCount();

        var targetIndex = index;

        if (index > this.__virtualizer.lastVisibleIndex - 1) {
          // Index is below the bottom, scrolling down. Make the item appear at the bottom.
          // First scroll to target (will be at the top of the scroller) to make sure it's rendered.
          this.__virtualizer.scrollToIndex(index); // Then calculate the index for the following scroll (to get the target to bottom of the scroller).


          targetIndex = index - visibleItemsCount + 1;
        } else if (index > this.__virtualizer.firstVisibleIndex) {
          // The item is already visible, scrolling is unnecessary per se. But we need to trigger iron-list to set
          // the correct scrollTop on the scrollTarget. Scrolling to firstVisibleIndex.
          targetIndex = this.__virtualizer.firstVisibleIndex;
        }

        this.__virtualizer.scrollToIndex(Math.max(0, targetIndex)); // Sometimes the item is partly below the bottom edge, detect and adjust.


        var lastPhysicalItem = _toConsumableArray(this.children).find(function (el) {
          return !el.hidden && el.index === _this2.__virtualizer.lastVisibleIndex;
        });

        if (!lastPhysicalItem || index !== lastPhysicalItem.index) {
          return;
        }

        var lastPhysicalItemRect = lastPhysicalItem.getBoundingClientRect();
        var scrollerRect = this.getBoundingClientRect();
        var scrollTopAdjust = lastPhysicalItemRect.bottom - scrollerRect.bottom + this._viewportTotalPaddingBottom;

        if (scrollTopAdjust > 0) {
          this.scrollTop += scrollTopAdjust;
        }
      }
      /**
       * @param {string | object} item
       * @param {string | object} selectedItem
       * @param {string} itemIdPath
       * @protected
       */

    }, {
      key: "_isItemSelected",
      value: function _isItemSelected(item, selectedItem, itemIdPath) {
        if (item instanceof ComboBoxPlaceholder) {
          return false;
        } else if (itemIdPath && item !== undefined && selectedItem !== undefined) {
          return get(itemIdPath, item) === get(itemIdPath, selectedItem);
        }

        return item === selectedItem;
      }
      /** @private */

    }, {
      key: "__itemsChanged",
      value: function __itemsChanged(items) {
        if (this.__virtualizer && items) {
          this.__virtualizer.size = items.length;

          this.__virtualizer.flush();

          this.requestContentUpdate();
        }
      }
      /** @private */

    }, {
      key: "__loadingChanged",
      value: function __loadingChanged() {
        this.requestContentUpdate();
      }
      /** @private */

    }, {
      key: "__openedChanged",
      value: function __openedChanged(opened) {
        if (opened) {
          this.requestContentUpdate();
        }
      }
      /** @private */

    }, {
      key: "__selectedItemChanged",
      value: function __selectedItemChanged() {
        this.requestContentUpdate();
      }
      /** @private */

    }, {
      key: "__focusedIndexChanged",
      value: function __focusedIndexChanged(index, oldIndex) {
        if (index !== oldIndex) {
          this.requestContentUpdate();
        } // Do not jump back to the previously focused item while loading
        // when requesting next page from the data provider on scroll.


        if (index >= 0 && !this.loading) {
          this.scrollIntoView(index);
        }
      }
      /** @private */

    }, {
      key: "__rendererChanged",
      value: function __rendererChanged(renderer, oldRenderer) {
        if (renderer || oldRenderer) {
          this.requestContentUpdate();
        }
      }
      /** @private */

    }, {
      key: "__createElements",
      value: function __createElements(count) {
        var _this3 = this;

        return _toConsumableArray(Array(count)).map(function () {
          var item = document.createElement("".concat(_this3.__hostTagName, "-item"));
          item.addEventListener('click', _this3.__boundOnItemClick); // Negative tabindex prevents the item content from being focused.

          item.tabIndex = '-1';
          item.style.width = '100%';
          return item;
        });
      }
      /**
       * @param {HTMLElement} el
       * @param {number} index
       * @protected
       */

    }, {
      key: "_updateElement",
      value: function _updateElement(el, index) {
        var item = this.items[index];
        var focusedIndex = this.focusedIndex;

        var selected = this._isItemSelected(item, this.selectedItem, this.itemIdPath);

        el.setProperties({
          item: item,
          index: index,
          label: this.getItemLabel(item),
          selected: selected,
          renderer: this.renderer,
          focused: !this.loading && focusedIndex === index
        });
        el.id = "".concat(this.__hostTagName, "-item-").concat(index);
        el.setAttribute('role', index !== undefined ? 'option' : false);
        el.setAttribute('aria-selected', selected.toString());
        el.setAttribute('aria-posinset', index + 1);
        el.setAttribute('aria-setsize', this.items.length);

        if (this.theme) {
          el.setAttribute('theme', this.theme);
        } else {
          el.removeAttribute('theme');
        }

        if (item instanceof ComboBoxPlaceholder) {
          this.__requestItemByIndex(index);
        }
      }
      /** @private */

    }, {
      key: "__onItemClick",
      value: function __onItemClick(e) {
        this.dispatchEvent(new CustomEvent('selection-changed', {
          detail: {
            item: e.currentTarget.item
          }
        }));
      }
      /**
       * We want to prevent the kinetic scrolling energy from being transferred from the overlay contents over to the parent.
       * Further improvement ideas: after the contents have been scrolled to the top or bottom and scrolling has stopped, it could allow
       * scrolling the parent similarly to touch scrolling.
       * @private
       */

    }, {
      key: "__patchWheelOverScrolling",
      value: function __patchWheelOverScrolling() {
        var _this4 = this;

        this.$.selector.addEventListener('wheel', function (e) {
          var scrolledToTop = _this4.scrollTop === 0;
          var scrolledToBottom = _this4.scrollHeight - _this4.scrollTop - _this4.clientHeight <= 1;

          if (scrolledToTop && e.deltaY < 0) {
            e.preventDefault();
          } else if (scrolledToBottom && e.deltaY > 0) {
            e.preventDefault();
          }
        });
      }
      /**
       * Dispatches an `index-requested` event for the given index to notify
       * the data provider that it should start loading the page containing the requested index.
       *
       * The event is dispatched asynchronously to prevent an immediate page request and therefore
       * a possible infinite recursion in case the data provider implements page request cancelation logic
       * by invoking data provider page callbacks with an empty array.
       * The infinite recursion may occur otherwise since invoking a data provider page callback with an empty array
       * triggers a synchronous scroller update and, if the callback corresponds to the currently visible page,
       * the scroller will synchronously request the page again which may lead to looping in the end.
       * That was the case for the Flow counterpart:
       * https://github.com/vaadin/flow-components/issues/3553#issuecomment-1239344828
       * @private
       */

    }, {
      key: "__requestItemByIndex",
      value: function __requestItemByIndex(index) {
        var _this5 = this;

        requestAnimationFrame(function () {
          _this5.dispatchEvent(new CustomEvent('index-requested', {
            detail: {
              index: index,
              currentScrollerPos: _this5._oldScrollerPosition
            }
          }));
        });
      }
      /** @private */

    }, {
      key: "_visibleItemsCount",
      value: function _visibleItemsCount() {
        // Ensure items are positioned
        this.__virtualizer.scrollToIndex(this.__virtualizer.firstVisibleIndex);

        var hasItems = this.__virtualizer.size > 0;
        return hasItems ? this.__virtualizer.lastVisibleIndex - this.__virtualizer.firstVisibleIndex + 1 : 0;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * A full set of items to filter the visible options from.
           * Set to an empty array when combo-box is not opened.
           */
          items: {
            type: Array,
            observer: '__itemsChanged'
          },

          /**
           * Index of an item that has focus outline and is scrolled into view.
           * The actual focus still remains in the input field.
           */
          focusedIndex: {
            type: Number,
            observer: '__focusedIndexChanged'
          },

          /**
           * Set to true while combo-box fetches new page from the data provider.
           */
          loading: {
            type: Boolean,
            observer: '__loadingChanged'
          },

          /**
           * Whether the combo-box is currently opened or not. If set to false,
           * calling `scrollIntoView` does not have any effect.
           */
          opened: {
            type: Boolean,
            observer: '__openedChanged'
          },

          /**
           * The selected item from the `items` array.
           */
          selectedItem: {
            type: Object,
            observer: '__selectedItemChanged'
          },

          /**
           * Path for the id of the item, used to detect whether the item is selected.
           */
          itemIdPath: {
            type: String
          },

          /**
           * Reference to the owner (combo-box owner), used by the item elements.
           */
          owner: {
            type: Object
          },

          /**
           * Function used to set a label for every combo-box item.
           */
          getItemLabel: {
            type: Object
          },

          /**
           * Function used to render the content of every combo-box item.
           */
          renderer: {
            type: Object,
            observer: '__rendererChanged'
          },

          /**
           * Used to propagate the `theme` attribute from the host element.
           */
          theme: {
            type: String
          }
        };
      }
    }]);

    return ComboBoxScrollerMixin;
  }(superClass);
};